const boltActionElement = require('./src/BoltActionElement.schema');

module.exports = {
  boltActionElement,
};
